import React from 'react';
import { useLocation } from 'react-router-dom';
import logoImage from '../images/landingPageAssets/onikanji-logo.png';
import usaFlagImage from '../images/landingPageAssets/onikanji-usa-flag.webp';
import japanFlagImage from '../images/landingPageAssets/onikanji-japan-flag.webp';
import { FaBluesky } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";


import { isAndroidApp, isInstalledApp } from '../services/appContext';
const Footer = () => {
    const { pathname } = useLocation();
    // Apps don't have website footers; the installed app shows these links in the menu.
    if (isInstalledApp()) return null;
    
    // Check if current page is related to the coin shop
    const isCoinShopRelated = pathname === '/get-coins' || 
                              pathname === '/purchase-success' || 
                              pathname === '/purchase-cancel';
    
    // Determine theme classes based on current page
    const footerTheme = isCoinShopRelated ? 
        'bg-gray-900 text-white' : 
        'bg-white text-black';
    
    const textSecondary = isCoinShopRelated ? 
        'text-gray-400' : 
        'text-gray-600';
    
    const borderColor = isCoinShopRelated ? 
        'border-gray-700' : 
        'border-gray-200';
    
    const linkColor = isCoinShopRelated ? 
        'text-gray-400 hover:text-oniKanjiPink' : 
        'text-gray-600 hover:text-logoColor';
    
    return (
        <footer className={`${footerTheme} py-12 max-sm:py-8 px-4 md:px-8 relative mt-auto transition-colors duration-300`}>

        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-evenly">
            <div className="mb-8 max-sm:mb-6 md:mb-0 text-center md:text-left">
                <img 
                    src={logoImage} 
                    alt="Onikanji Logo" 
                    className="h-12 max-sm:h-10 md:h-16 mb-6 max-sm:mb-4 mx-auto md:mx-0 cursor-pointer"
                    onClick={() => window.location.href = '/'} 
                />
                <div className="mb-6">
                    <p className="text-lg mb-2">
                        Made with love from <img src={usaFlagImage} alt="USA Flag" className="inline w-5 h-5" /> & <img src={japanFlagImage} alt="Japan Flag" className="inline w-5 h-5" />
                    </p>
                    <p className={`text-sm ${textSecondary}`}>
                        © {new Date().getFullYear()} OniKanji Education LLC. All rights reserved.
                    </p>
                </div>
                <div className="flex justify-center md:justify-start space-x-4">
                    <a href="https://bsky.app/profile/onikanji.bsky.social" className={`${linkColor} transition-colors duration-300`}>
                        <FaBluesky className="w-6 h-6" />
                    </a>
                    <a href="https://www.tiktok.com/@onikanji6" className={`${linkColor} transition-colors duration-300`}>
                        <FaTiktok className="w-6 h-6" />
                    </a>
                    <a href="https://discord.gg/7TEG9cqZTP" className={`${linkColor} transition-colors duration-300`}>
                        <FaDiscord className="w-7 h-7" />
                    </a>
                </div>
            </div>
            <div className="w-full md:w-1/2 mb-8 max-sm:mb-6 md:mb-0 flex flex-col md:flex-row justify-center space-y-8 md:space-y-0 md:space-x-16 max-sm:flex-row max-sm:space-y-0 max-sm:justify-around text-center md:text-left">
                <div>
                    <h4 className="font-bold text-lg mb-4 max-sm:text-base max-sm:mb-2">Company</h4>
                    <ul className="space-y-2 max-sm:space-y-0 max-sm:text-sm max-sm:[&_a]:inline-block max-sm:[&_a]:py-2">
                        <li><a href="https://discord.gg/7TEG9cqZTP" className={`${linkColor} transition-colors duration-300`}>Discord</a></li>
                        {!isAndroidApp() && <li><a href="/pricing" className={`${linkColor} transition-colors duration-300`}>Pricing</a></li>}
                        <li><a href="https://community.onikanji.com/" className={`${linkColor} transition-colors duration-300`}>Knowledge Center</a></li>
                        <li><a href="https://community.onikanji.com/t/why-onikanji-is-onikanji-right-for-me" className={`${linkColor} transition-colors duration-300`}>Our Method</a></li>
                        <li><a href="https://community.onikanji.com/" className={`${linkColor} transition-colors duration-300`}>FAQs</a></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-bold text-lg mb-4 max-sm:text-base max-sm:mb-2">Connect</h4>
                    <ul className="space-y-2 max-sm:space-y-0 max-sm:text-sm max-sm:[&_a]:inline-block max-sm:[&_a]:py-2">
                        <li><a href="/about-us" className={`${linkColor} transition-colors duration-300`}>About Us</a></li>
                        <li><a href="/about-us" className={`${linkColor} transition-colors duration-300`}>Join Our Team</a></li>
                        <li><a href="https://community.onikanji.com/t/contact-us" className={`${linkColor} transition-colors duration-300`}>Contact Us</a></li>
                        <li><a href="https://community.onikanji.com/t/privacy-policy" className={`${linkColor} transition-colors duration-300`}>Privacy Policy</a></li>
                        <li><a href="https://community.onikanji.com/t/terms-of-service-and-use" className={`${linkColor} transition-colors duration-300`}>Terms of Service</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div className={`mt-12 border-t ${borderColor} pt-8`}>
            <p className={`text-center ${textSecondary} text-sm`}>
                By using this site, you agree to our <a href="https://community.onikanji.com/t/terms-of-service-and-use" className={`${isCoinShopRelated ? 'text-oniKanjiPink' : 'text-logoColor'} hover:underline`}>Terms of Service</a> and <a href="https://community.onikanji.com/t/privacy-policy" className={`${isCoinShopRelated ? 'text-oniKanjiPink' : 'text-logoColor'} hover:underline`}>Privacy Policy</a>.
            </p>
        </div>
    </footer>
    );
};

export default Footer;